// Force default values for react-beautiful-dnd Droppable to ensure compatibility with React 19
export const DROPPABLE_DEFAULT_PROPS = {
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  mode: 'standard',
  direction: 'vertical',
  renderClone: null,
};
